import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Shop from "../pages/shop/page";
import Story from "../pages/story/page";
import Sustainability from "../pages/sustainability/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/shop",
    element: <Shop />,
  },
  {
    path: "/story",
    element: <Story />,
  },
  {
    path: "/sustainability",
    element: <Sustainability />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;